import { render, staticRenderFns } from "./ModalTeamRoleAssign.vue?vue&type=template&id=257d1ab4&"
import script from "./ModalTeamRoleAssign.vue?vue&type=script&lang=js&"
export * from "./ModalTeamRoleAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports